import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button, { ButtonType, ButtonTheme } from '../../atoms/button/button';
// eslint-disable-next-line import/no-cycle
import LoadFromCatalog from '../../organisms/loadFromCatalogModal/loadFromCatalogModal';
import { IconType } from '../../atoms/icon/icon';

const LoadFromRelatedTableButton = (props) => {
  const {
    id,
    label,
    buttonText,
    buttonTheme,
    icon,
    configFile,
    aditionalData,
    onClose,
    selectedValue,
    disabled,
    popupSize
  } = props;

  const [openModal, setOpenModal] = useState(false);


  const onClickOpenModal = () => {
    setOpenModal(true);
  };

  const handleClose = (response) => {
    onClose(response);
    setOpenModal(false);
  };

  return (
    <div className="d-inline">
      <Button
        id={id}
        type={ButtonType.BUTTON}
        theme={buttonTheme}
        onClick={onClickOpenModal}
        icon={icon}
        disabled={disabled}
      >
        {buttonText}
      </Button>
      { openModal
      && (
        <LoadFromCatalog
          onClose={handleClose}
          title={`Load ${label}`}
          configFile={configFile}
          aditionalData={aditionalData}
          selectedValue={selectedValue}
          size={popupSize?popupSize:null}
        />
      )}
    </div>
  );
};

LoadFromRelatedTableButton.propTypes = {
  /**
   * Id of search button
   */
  id: PropTypes.string,
  /**
   * Name of input attribute
   */
  label: PropTypes.string,
  /**
   * Button title
   */
  buttonText: PropTypes.string,
  /**
   * Button type
   */
  buttonTheme: PropTypes.oneOf(Object.values(ButtonTheme)),
  /**
   * Confinguration file to create a table
   */
  configFile: PropTypes.shape({}),
  /**
   * data attributes to bind to the create function
   */
  aditionalData: PropTypes.shape({}),
  /**
   * To select a icon inside the button
   */
  icon: PropTypes.oneOf(Object.values(IconType)),
  /**
   * Event callback when the modal is closed
   */
  onClose: PropTypes.func,
};

LoadFromRelatedTableButton.defaultProps = {
  id:'',
  label: '',
  buttonText: 'Load from catalog',
  buttonTheme: ButtonTheme.LINK,
  configFile: {},
  aditionalData: undefined,
  icon: '',
  onClose: () => { },
};

export default LoadFromRelatedTableButton;
